import React from "react";
import "./credStory.css";

const CredStory = () => {
  return (
    <div className="cred-story flex absolute-center">
      <div className="max-width flex story-wrapper">
        <div className="story-heading-wrapper flex">
          <div className="story-heading">
          the story of Crosswalk begins with trust.
          </div>
        </div>
        <div className="story-description">
          <div className="story-para">
          trust is the base of every strong financial decision, yet it is often ignored. we built Crosswalk to change that.
          our goal is simple: create a system where investors can rely on clear data, smart tech, and transparent insights. a place where your money is handled with care, honesty, and intelligence.
          </div>
          <div className="story-para">
          so we built a platform that uses AI, real-time analysis, and strong security to guide your investments—without the noise, doubt, or hidden tricks.
          </div>
          <div className="story-para">
          if you're here, it means you value smart and trustworthy investing.
          welcome to Crosswalk. a better way to grow your money.
          </div>
        </div>
      </div>
    </div>
  );
};

export default CredStory;
